import { render, staticRenderFns } from "./MyPermissionsDialog.vue?vue&type=template&id=cbc454ee&scoped=true"
import script from "./MyPermissionsDialog.vue?vue&type=script&lang=ts"
export * from "./MyPermissionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./MyPermissionsDialog.vue?vue&type=style&index=0&id=cbc454ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc454ee",
  null
  
)

export default component.exports